export const POPUP_OPEN = 'POPUP_OPEN';
export const RESET_ALL_REDUCER = 'RESET_ALL_REDUCER';
export const POPUP_CLOSE = 'POPUP_CLOSE';
export const GET_COUNTRY_STATE_CITY_LIST_SAGA = 'GET_COUNTRY_STATE_CITY_LIST_SAGA';
export const GET_SIGNED_ASSESSEE_PERMISSION_SAGA = 'GET_SIGNED_ASSESSEE_PERMISSION_SAGA';
export const FORGOT_PASSWORD_SAGA = 'FORGOT_PASSWORD_SAGA';
export const SET_USER = 'SET_USER';
export const SEND_AUTH_CODE_FORGOT_PASS = 'SEND_AUTH_CODE_FORGOT_PASSSEND_AUTH_CODE_FORGOT_PASS';
export const SEND_FORGOT_CREDENTIAL_SAGA = 'SEND_FORGOT_CREDENTIAL_SAGA';
export const SET_SIGN_IN_STATUS = 'SET_SIGN_IN_STATUS';
export const SET_USER_STATE = 'SET_USER_STATE';
export const SET_ASSESSEE_REVISE_PASSWORD = 'SET_ASSESSEE_REVISE_PASSWORD';
export const SET_ASSESSEE_PERMISSION = 'SET_ASSESSEE_PERMISSION';
export const GET_ASSESSES_SAGA = 'GET_ASSESSES_SAGA';
export const ASSESSEE_SIGN_ON = 'ASSESSEE_SIGN_ON';
export const ASSESSEE_SIGN_IN_SAGA = 'ASSESSEE_SIGN_IN_SAGA';
export const REFRESH_TOKENS = 'REFRESH_TOKENS';
// export const REFRESH_TOKENSX = 'REFRESH_TOKENSX';
// export const REQUEST_FAIL = 'REQUEST_FAIL';
export const GET_ASSESSEE_SIGN_IN_INFO = 'GET_ASSESSEE_SIGN_IN_INFO';
export const SET_DISPLAY_PANE_FOUR_SHOW = 'SET_DISPLAY_PANE_FOUR_SHOW';
export const SET_GRID_COLUMN_COUNT_VALUE = 'SET_GRID_COLUMN_COUNT_VALUE';
export const SET_SECONDARY_OPTION_VALUE = 'SET_SECONDARY_OPTION_VALUE';
export const SET_SECONDARY_CREATE_OPTION_VALUE = 'SET_SECONDARY_CREATE_OPTION_VALUE';
export const SET_MOBILE_PANE_STATE = 'SET_MOBILE_PANE_STATE';
export const GET_ALLOCATE_ITEM = 'GET_ALLOCATE_ITEM';
export const GET_ALLOCATE_ITEM_GROUP = 'GET_ALLOCATE_ITEM_GROUP';
export const SET_SIGN_ON_SINGLE_STATE = 'SET_SIGN_ON_SINGLE_STATE';
export const CLEAR_SIGN_ON_SINGLE_STATE = 'CLEAR_SIGN_ON_SINGLE_STATE';
export const ASSOCIATE_SIGN_ON = 'ASSOCIATE_SIGN_ON';
export const SET_NEXT_POPUP = 'SET_NEXT_POPUP';
export const PREVIOUS_POPUP = 'PREVIOUS_POPUP';
export const SET_POPUP_STATE = 'SET_POPUP_STATE';
export const SET_MIDDLEPANE_SECONDARY_OPTION = 'SET_MIDDLEPANE_SECONDARY_OPTION';
export const SET_MIDDLEPANE_PREVIOUS_POPUP = 'SET_MIDDLEPANE_PREVIOUS_POPUP';
export const SET_MIDDLEPANE_REVIEW_LIST_PREVIOUS_POPUP = 'SET_MIDDLEPANE_REVIEW_LIST_PREVIOUS_POPUP';
export const SET_BRAND_LOGO_TYPE = 'SET_BRAND_LOGO_TYPE';
// set middle pane states
export const SET_MIDDLEPANE_STATE = 'SET_MIDDLEPANE_STATE';
export const SET_SELECTED_ASSOCIATE = 'SET_SELECTED_ASSOCIATE';
export const LOADER_START = 'LOADER_START';
export const GET_ASSESSEE_REPORT_SAGA = 'GET_ASSESSEE_REPORT_SAGA';
export const GET_ASSIGNMENT_REPORT_SAGA = 'GET_ASSIGNMENT_REPORT_SAGA';
export const GET_ASSIGNMENT_REPORT_INFO_SAGA = 'GET_ASSIGNMENT_REPORT_INFO_SAGA';
export const LOADER_STOP = 'LOADER_STOP';
export const SET_PAGE_COUNT = 'SET_PAGE_COUNT';
export const SET_POPUP_VALUE = 'SET_POPUP_VALUE';
export const SET_SCAN_POPUP_STATE = 'SET_SCAN_POPUP_STATE';
export const CLEAR_POPUP_INFO = 'CLEAR_POPUP_INFO';
export const SET_POPUP_SINGLE_STATE = 'SET_POPUP_SINGLE_STATE';
export const GET_ALLOCATE_ASSESSEE = 'GET_ALLOCATE_ASSESSEE';
export const GET_ALLOCATE_ASSESSEE_GROUP = 'GET_ALLOCATE_ASSESSEE_GROUP';
export const GET_ALLOCATE_ADMINISTRATOR = 'GET_ALLOCATE_ADMINISTRATOR';
export const GET_ALLOCATE_ASSOCIATE = 'GET_ALLOCATE_ASSOCIATE';
export const GET_ALLOCATE_ASSESSMENT = 'GET_ALLOCATE_ASSESSMENT';
export const GET_ALLOCATE_ASSESSMENT_GROUP = 'GET_ALLOCATE_ASSESSMENT_GROUP';
export const GET_ALLOCATE_ASSIGNMENT = 'GET_ALLOCATE_ASSIGNMENT';
export const GET_SIGNED_ASSESEE_NOTIFICATION = 'GET_SIGNED_ASSESEE_NOTIFICATION';
export const SET_ASSESSEE_ASSESSMENT_ITEM_RES_SAGA = 'SET_ASSESSEE_ASSESSMENT_ITEM_RES_SAGA';
export const ASSESSEE_ASSESSMENT_FINISH_SAGA = 'ASSESSEE_ASSESSMENT_FINISH_SAGA';
// for assessee information
export const ASSESSEE_INFO_CREATE = 'ASSESSEE_INFO_CREATE';
export const ASSESSEE_CREATE = 'ASSESSEE_CREATE';
export const SET_DISPLAY_TWO_SINGLE_STATE = 'SET_DISPLAY_TWO_SINGLE_STATE';
export const CLEAR_PANE_TWO_REDUCER = 'CLEAR_PANE_TWO_REDUCER';
export const SET_DISPLAY_THREE_SINGLE_STATE = 'SET_DISPLAY_THREE_SINGLE_STATE';
export const SET_ASSESSEE_DYNAMIC_SINGLE_STATE = 'SET_ASSESSEE_DYNAMIC_SINGLE_STATE';
export const UPDATE_ASSESSEE_CONTACT_INFO = 'UPDATE_ASSESSEE_CONTACT_INFO';
export const SET_NODE_DYNAMIC_SINGLE_STATE = 'SET_NODE_DYNAMIC_SINGLE_STATE';
export const SET_ASSOCIATE_NODE_CLASSIFICAION_STATE = 'SET_ASSOCIATE_NODE_CLASSIFICAION_STATE';
export const SET_ASSOCIATE_NODE_PARENT_STATE = 'SET_ASSOCIATE_NODE_PARENT_STATE';
export const SET_ROLE_DYNAMIC_STATE = 'SET_ROLE_DYNAMIC_STATE';
export const SET_SETUP_PERMISSION = 'SET_SETUP_PERMISSION';
export const SET_SETUP_PERMISSION_NEW = 'SET_SETUP_PERMISSION_NEW';
export const SET_ROLE_REDUCER_STATE = 'SET_ROLE_REDUCER_STATE';
export const UPDATE_ASSESSEE_CONTACT_DYNAMIC_SINGLE_STATE =
  'UPDATE_ASSESSEE_CONTACT_DYNAMIC_SINGLE_STATE';
export const UPDATE_ASSESSEE_INFO = 'UPDATE_ASSESSEE_INFO';
export const UPDATE_ASSESSEE_BASIC_INFO = 'UPDATE_ASSESSEE_BASIC_INFO';
export const UPDATE_ASSESSEE_ALIAS_INFO = 'UPDATE_ASSESSEE_ALIAS_INFO';
export const UPDATE_ASSESSEE_MOBILE_INFO = 'UPDATE_ASSESSEE_MOBILE_INFO';
export const UPDATE_ASSESSEE_TELEPHONE_HOME_INFO = 'UPDATE_ASSESSEE_TELEPHONE_HOME_INFO';
export const UPDATE_ASSESSEE_TELEPHONE_WORK_PRIMARY_INFO = 'UPDATE_ASSESSEE_TELEPHONE_WORK_PRIMARY_INFO';
export const UPDATE_ASSESSEE_TELEPHONE_WORK_SECONDARY_INFO = 'UPDATE_ASSESSEE_TELEPHONE_WORK_SECONDARY_INFO';
export const UPDATE_ASSESSEE_PERSONAL_INFO = 'UPDATE_ASSESSEE_PERSONAL_INFO';
export const UPDATE_ASSESSEE_HOMEADDRESS_INFO = 'UPDATE_ASSESSEE_HOMEADDRESS_INFO';
export const UPDATE_ASSESSEE_WORKADDRESS_INFO = 'UPDATE_ASSESSEE_WORKADDRESS_INFO';
export const UPDATE_ASSESSEE_MOBILE_SECONDARY_INFO = 'UPDATE_ASSESSEE_MOBILE_SECONDARY_INFO';
export const UPDATE_ASSESSEE_TAG_STATUTORY_INFO = 'UPDATE_ASSESSEE_TAG_STATUTORY_INFO';
export const SET_AVAILABLE_SIGNIN_LIST = 'SET_AVAILABLE_SIGNIN_LIST';
export const SET_CURRENTLY_SIGNIN_CREDENTIAL = 'SET_CURRENTLY_SIGNIN_CREDENTIAL';
export const UPDATE_ASSESSEE_WORKADDRESS_SECONDARY_INFO =
  'UPDATE_ASSESSEE_WORKADDRESS_SECONDARY_INFO';
export const UPDATE_ASSESSEE_TELEPHONE_HOME_SECONDARY_INFO =
  'UPDATE_ASSESSEE_TELEPHONE_HOME_SECONDARY_INFO';
export const UPDATE_ASSESSEE_HOMEADDRESS_SECONDARY_INFO =
  'UPDATE_ASSESSEE_HOMEADDRESS_SECONDARY_INFO';
export const UPDATE_ASSESSEE_ADDRESS_EMAIL_PRIMARY_INFO =
  'UPDATE_ASSESSEE_ADDRESS_EMAIL_PRIMARY_INFO';
export const UPDATE_ASSESSEE_ADDRESS_EMAIL_SECONDARY_INFO =
  'UPDATE_ASSESSEE_ADDRESS_EMAIL_SECONDARY_INFO';
export const UPDATE_ASSESSEE_SETUP_PRIMARY_INFO = 'UPDATE_ASSESSEE_SETUP_PRIMARY_INFO';
export const SET_ITEM_FRAMWORK_TYPE = 'SET_ITEM_FRAMWORK_TYPE';
export const UPDATE_ASSESSEE_ENGAGEMENT_INFO = 'UPDATE_ASSESSEE_ENGAGEMENT_INFO';
export const CLEAR_ASSESSEE_INFO = 'CLEAR_ASSESSEE_INFO';
export const UPDATE_ASSESSEE_COMMUNICATION = 'UPDATE_ASSESSEE_COMMUNICATION';
export const SET_ASSESSEE_INFORMATION_DATA = 'SET_ASSESSEE_INFORMATION_DATA';
export const SET_ASSESSEE_CREATE_SINGLE_STATE = 'SET_ASSESSEE_CREATE_SINGLE_STATE';
export const SET_ASSOCIATE_CREATE_SINGLE_STATE = 'SET_ASSOCIATE_CREATE_SINGLE_STATE';
export const REVIEWLIST_DISTINCT_DATA = 'REVIEWLIST_DISTINCT_DATA';
export const RELATED_REVIEWLIST_DISTINCT_DATA = 'RELATED_REVIEWLIST_DISTINCT_DATA';
export const SET_REQUEST_OBJECT = 'SET_REQUEST_OBJECT';
export const SET_RELATED_REQUEST_OBJECT = 'SET_RELATED_REQUEST_OBJECT';
export const SET_CORE_REVIEW_LIST_DATA = 'SET_CORE_REVIEW_LIST_DATA';
export const SET_CORE_GROUP_REVIEW_LIST_REQ_OBJECT = 'SET_CORE_GROUP_REVIEW_LIST_REQ_OBJECT';
export const SET_CORE_ROLE_REVIEW_LIST_REQ_OBJECT = 'SET_CORE_ROLE_REVIEW_LIST_REQ_OBJECT';
export const SET_CORE_TYPE_REVIEW_LIST_REQ_OBJECT = 'SET_CORE_TYPE_REVIEW_LIST_REQ_OBJECT';
export const SET_CORE_NODE_REVIEW_LIST_REQ_OBJECT = 'SET_CORE_NODE_REVIEW_LIST_REQ_OBJECT';
export const SET_DYNAMIC_REVIEW_LIST_REQ_OBJECT = 'SET_DYNAMIC_REVIEW_LIST_REQ_OBJECT';
export const SET_CORE_GROUP_REVIEW_LIST_DATA = 'SET_CORE_GROUP_REVIEW_LIST_DATA';
export const SET_CORE_ROLE_REVIEW_LIST_DATA = 'SET_CORE_ROLE_REVIEW_LIST_DATA';
export const SET_CORE_TYPE_REVIEW_LIST_DATA = 'SET_CORE_TYPE_REVIEW_LIST_DATA';
export const SET_CORE_NODE_REVIEW_LIST_DATA = 'SET_CORE_NODE_REVIEW_LIST_DATA';
export const SET_DYNAMIC_REVIEW_LIST_DATA = 'SET_DYNAMIC_REVIEW_LIST_DATA';
export const UPDATE_ASSESSEE_COMMUNITY_SOCIAL_INFO = 'UPDATE_ASSESSEE_COMMUNITY_SOCIAL_INFO';
export const GET_CULTURE_PROFILE_INFO_SAGA = 'GET_CULTURE_PROFILE_INFO_SAGA';
export const GET_CULTURE_DIAMENTION_SAGA = 'GET_CULTURE_DIAMENTION_SAGA';
export const GET_JOB_PROFILE_INFO_SAGA = 'GET_JOB_PROFILE_INFO_SAGA';
export const CULTURE_PROFILE_INFO_REVISE_SAGA = 'CULTURE_PROFILE_INFO_REVISE_SAGA';
export const CULTURE_PROFILE_PUBLISHED_SAGA = 'CULTURE_PROFILE_PUBLISHED_SAGA';
export const JOB_PROFILE_INFO_REVISE_SAGA = 'JOB_PROFILE_INFO_REVISE_SAGA';
export const UPDATE_ASSESSEE_COMMUNITY_SPIRITUAL_INFO = 'UPDATE_ASSESSEE_COMMUNITY_SPIRITUAL_INFO';

export const SET_ASSESSEE_ROLE_REDUCER_STATE = 'SET_ASSESSEE_ROLE_REDUCER_STATE';
export const SET_ASSOCIATE_ROLE_REDUCER_STATE = 'SET_ASSOCIATE_ROLE_REDUCER_STATE';
export const CLEAR_ROLE_REDUCER_STATE = 'CLEAR_ROLE_REDUCER_STATE';
export const SET_ASSESSEE_GROUP_REDUCER_STATE = 'SET_ASSESSEE_GROUP_REDUCER_STATE';
export const SET_ASSESSMENT_GROUP_REDUCER_STATE = 'SET_ASSESSMENT_GROUP_REDUCER_STATE';
export const SET_ASSIGNMEMT_GROUP_REDUCER_STATE = 'SET_ASSIGNMEMT_GROUP_REDUCER_STATE';
export const SET_ASSOCIATE_GROUP_REDUCER_STATE = 'SET_ASSOCIATE_GROUP_REDUCER_STATE';
export const CLEAR_GROUP_REDUCER_STATE = 'CLEAR_GROUP_REDUCER_STATE';
export const CLEAR_TYPE_REDUCER_STATE = 'CLEAR_TYPE_REDUCER_STATE';
export const CLEAR_NODE_REDUCER_STATE = 'CLEAR_NODE_REDUCER_STATE';
export const SET_TYPE_REDUCER_STATE = 'SET_TYPE_REDUCER_STATE';
export const SET_ITEM_SETUP_INFO_STATE = 'SET_ITEM_SETUP_INFO_STATE';
export const SET_ITEM_SINGLE_STATE = 'SET_ITEM_SINGLE_STATE';
export const SET_CULTURE_REDUCER_STATE = 'SET_CULTURE_REDUCER_STATE';
export const SET_CULTURE_DIMENTION_STATE = 'SET_CULTURE_DIMENTION_STATE';
export const SET_CULTURE_SETUP_INFO_STATE = 'SET_CULTURE_SETUP_INFO_STATE';
export const SET_WEIGHTAGE_CULTURE_PROFILE = 'SET_WEIGHTAGE_CULTURE_PROFILE';
export const SET_CULTURE_DYANMIC_DIMENTION_STATE = 'SET_CULTURE_DYANMIC_DIMENTION_STATE';
export const SET_JOB_REDUCER_STATE = 'SET_JOB_REDUCER_STATE';
export const SET_JOB_SETUP_INFO_STATE = 'SET_JOB_SETUP_INFO_STATE';
export const SET_ASSESSEE_TYPE_REDUCER_STATE = 'SET_ASSESSEE_TYPE_REDUCER_STATE';
export const SET_ASSESSMENT_TYPE_REDUCER_STATE = 'SET_ASSESSMENT_TYPE_REDUCER_STATE';
export const SET_ASSIGNMENT_TYPE_REDUCER_STATE = 'SET_ASSIGNMENT_TYPE_REDUCER_STATE';
export const SET_ASSOCIATE_TYPE_REDUCER_STATE = 'SET_ASSOCIATE_TYPE_REDUCER_STATE';
export const SET_NODE_REDUCER_STATE = 'SET_NODE_REDUCER_STATE';
export const SET_ITEM_TYPE_REDUCER_STATE = 'SET_ITEM_TYPE_REDUCER_STATE';
//for assessments SAGA
export const GET_ASSESSMENT_GROUP_REVIEW_LIST_SAGA = 'GET_ASSESSMENT_GROUP_REVIEW_LIST_SAGA';
export const GET_ASSESSMENT_TYPE_REVIEW_LIST_SAGA = 'GET_ASSESSMENT_TYPE_REVIEW_LIST_SAGA';
export const ASSESSMENT_REVIEW_DISTINCT_SAGA = 'ASSESSMENT_REVIEW_DISTINCT_SAGA';
export const CREATE_ASSESSMENT_SAGA = 'CREATE_ASSESSMENT_SAGA';
export const CREATE_ASSESSMENT_SECTION_SAGA = 'CREATE_ASSESSMENT_SECTION_SAGA';
export const CREATE_ITEM_SAGA = 'CREATE_ITEM_SAGA';
export const GET_ITEM_REVIEW_LIST_SAGA = 'GET_ITEM_REVIEW_LIST_SAGA';
export const GET_ITEM_GROUP_REVIEW_LIST_SAGA = 'GET_ITEM_GROUP_REVIEW_LIST_SAGA';
export const SET_ITEM_GROUP_REDUCER_STATE = 'SET_ITEM_GROUP_REDUCER_STATE';
export const SET_CULTURE_GROUP_REDUCER_STATE = 'SET_CULTURE_GROUP_REDUCER_STATE';
export const SET_JOB_GROUP_REDUCER_STATE = 'SET_JOB_GROUP_REDUCER_STATE';
export const GET_NODE_ITEMS_REVIEW_LIST_SAGA = 'GET_NODE_ITEMS_REVIEW_LIST_SAGA';
export const SET_GROUP_ALLOCATION_STATE = 'SET_GROUP_ALLOCATION_STATE';
export const ASSESSMENT_START_SAGA = 'ASSESSMENT_START_SAGA';
export const SET_GROUP_SETUP_STATE = 'SET_GROUP_SETUP_STATE';
export const SET_ASSESSEE_CLASSIFICAION_STATE = 'SET_ASSESSEE_CLASSIFICAION_STATE';
export const SET_ASSESSMENT_CLASSIFICAION_STATE = 'SET_ASSESSMENT_CLASSIFICAION_STATE';
export const SET_GROUPS_SELL_FEE_STATE = 'SET_GROUPS_SELL_FEE_STATE';
export const SET_GROUPS_MOVE_FEE_STATE = 'SET_GROUPS_MOVE_FEE_STATE';
export const SET_GROUPS_SHARE_FEE_STATE = 'SET_GROUPS_SHARE_FEE_STATE';
export const SET_ASSOCIATE_CLASSIFICAION_STATE = 'SET_ASSOCIATE_CLASSIFICAION_STATE';
export const SET_ASSIGNMENT_CLASSIFICAION_STATE = 'SET_ASSIGNMENT_CLASSIFICAION_STATE';
export const SET_ITEM_CLASSIFICAION_STATE = 'SET_ITEM_CLASSIFICAION_STATE';
export const SET_GROUP_ALLOCATION_GROUP_ASCENDANT_STATE =
  'SET_GROUP_ALLOCATION_GROUP_ASCENDANT_STATE';
export const SET_CULTUREPROFILE_CLASSIFICAION_STATE = 'SET_CULTUREPROFILE_CLASSIFICAION_STATE';
export const SET_JOBPROFILE_CLASSIFICAION_STATE = 'SET_JOBPROFILE_CLASSIFICAION_STATE';

export const SET_ASSESSEE_TYPE_CLASSIFICAION_STATE = 'SET_ASSESSEE_TYPE_CLASSIFICAION_STATE';
export const SET_ASSESSMENT_TYPE_CLASSIFICAION_STATE = 'SET_ASSESSMENT_TYPE_CLASSIFICAION_STATE';
export const SET_ASSOCIATE_TYPE_CLASSIFICAION_STATE = 'SET_ASSOCIATE_TYPE_CLASSIFICAION_STATE';
export const SET_ASSIGNMENT_TYPE_CLASSIFICAION_STATE = 'SET_ASSIGNMENT_TYPE_CLASSIFICAION_STATE';
export const SET_ITEM_TYPE_CLASSIFICAION_STATE = 'SET_ITEM_TYPE_CLASSIFICAION_STATE';
export const SET_CULTUREPROFILE_TYPE_CLASSIFICAION_STATE =
  'SET_CULTUREPROFILE_TYPE_CLASSIFICAION_STATE';
export const SET_JOBPROFILE_TYPE_CLASSIFICAION_STATE = 'SET_JOBPROFILE_TYPE_CLASSIFICAION_STATE';

export const SET_ASSESSEE_ROLE_CLASSIFICAION_STATE = 'SET_ASSESSEE_ROLE_CLASSIFICAION_STATE';
export const SET_ASSOCIATE_ROLE_CLASSIFICAION_STATE = 'SET_ASSOCIATE_ROLE_CLASSIFICAION_STATE';
export const ASSESSMENT_MULTI_STATUS_REVISE_SAGA = 'ASSESSMENT_MULTI_STATUS_REVISE_SAGA';
//reset
export const RESET_ASSESSEE_ASSIGNMENT_SAGA = 'RESET_ASSESSEE_ASSIGNMENT_SAGA';
export const ASSESSEE_ASSIGNMENT_RESET_SAGA = 'ASSESSEE_ASSIGNMENT_RESET_SAGA';
export const ASSESSEE_ASSIGNMENT_ASSESSMENT_RESET_SAGA =
  'ASSESSEE_ASSIGNMENT_ASSESSMENT_RESET_SAGA';
export const ASSIGNMENT_RESET_SAGA = 'ASSIGNMENT_RESET_SAGA';
export const ASSIGNMENT_ASSESSMENT_RESET_SAGA = 'ASSIGNMENT_ASSESSMENT_RESET_SAGA';
export const ASSIGNEMT_ASSESEES_ASSESSMENT_RESET_SAGA = 'ASSIGNEMT_ASSESEES_ASSESSMENT_RESET_SAGA';
//for assignments SAGA
export const GET_ASSIGNMENT_GROUP_REVIEW_LIST_SAGA = 'GET_ASSIGNMENT_GROUP_REVIEW_LIST_SAGA';
export const GET_ASSIGNMENT_TYPE_REVIEW_LIST_SAGA = 'GET_ASSIGNMENT_TYPE_REVIEW_LIST_SAGA';
export const ASSIGNMENT_REVIEW_LIST_DISTINCT_SAGA = 'ASSIGNMENT_REVIEW_LIST_DISTINCT_SAGA';
export const CREATE_ASSIGNMENT_SAGA = 'CREATE_ASSIGNMENT_SAGA';
export const ASSIGNMENT_ADMINISTER_SAGA = 'ASSIGNMENT_ADMINISTER_SAGA';
//for assesees SAGA
export const GET_ASSESSEE_ROLE_REVIEW_LIST_SAGA = 'GET_ASSESSEE_ROLE_REVIEW_LIST_SAGA';
export const GET_ASSESSEE_GROUP_REVIEW_LIST_SAGA = 'GET_ASSESSEE_GROUP_REVIEW_LIST_SAGA';
export const GET_ASSESSEE_TYPE_REVIEW_LIST_SAGA = 'GET_ASSESSEE_TYPE_REVIEW_LIST_SAGA';
export const GET_ASSESSEE_ROLE_REVIEW_INFO_SAGA = 'GET_ASSESSEE_ROLE_REVIEW_INFO_SAGA';
export const GET_ASSOCIATE_ROLE_REVIEW_INFO_SAGA = 'GET_ASSOCIATE_ROLE_REVIEW_INFO_SAGA';
export const GET_ASSESSEE_ROLE_GROUP_REVIEW_LIST_SAGA = 'GET_ASSESSEE_ROLE_GROUP_REVIEW_LIST_SAGA';
export const CREATE_ASSESSEE_SAGA = 'CREATE_ASSESSEE_SAGA';
export const CREATE_ASSESSEE_ROLE_SAGA = 'CREATE_ASSESSEE_ROLE_SAGA';
export const ASSESSEE_REVIEW_DISTINCT_SAGA = 'ASSESSEE_REVIEW_DISTINCT_SAGA';
export const SET_TYPE_GROUP_ALLOCATION = 'SET_TYPE_GROUP_ALLOCATION';
export const CREATE_GROUP_SAGA = 'CREATE_GROUP_SAGA';
export const CREATE_TYPE_SAGA = 'CREATE_TYPE_SAGA';
export const CLEAR_ITEM_REDUCER_STATE = 'CLEAR_ITEM_REDUCER_STATE';
export const CLEAR_CULTURE_REDUCER_STATE = 'CLEAR_CULTURE_REDUCER_STATE';
export const CLEAR_JOB_REDUCER_STATE = 'CLEAR_JOB_REDUCER_STATE';
export const ASSESSEE_CONFIRM_SAGA = 'ASSESSEE_CONFIRM_SAGA';
export const SET_SINGLE_ASSOCIATE_INFORMATION = 'SET_SINGLE_ASSOCIATE_INFORMATION';
export const UPDATE_ASSOCIATE_WEBSITE_INFO = 'UPDATE_ASSOCIATE_WEBSITE_INFO';
export const UPDATE_ASSOCIATE_WEBSITE_PRIMARY_INFO = 'UPDATE_ASSOCIATE_WEBSITE_PRIMARY_INFO';
export const UPDATE_ASSOCIATE_WEBSITE_SECONDARY_INFO = 'UPDATE_ASSOCIATE_WEBSITE_SECONDARY_INFO';
export const UPDATE_ASSOCIATE_INFO_CONTACT_INFO = 'UPDATE_ASSOCIATE_INFO_CONTACT_INFO';
export const UPDATE_ASSOCIATE_WORKTELEPHONE_SECONDARY_INFO =
  'UPDATE_ASSOCIATE_WORKTELEPHONE_SECONDARY_INFO';
//export const SHARE_ROLES_TYPES_SAGA = 'SHARE_ROLES_TYPES_SAGA';
export const SHARE_GROUPS_ROLES_TYPES_SAGA = 'SHARE_GROUPS_ROLES_TYPES_SAGA';
export const ASSOCIATE_DISTINCT_SHARE_SAGA = 'ASSOCIATE_DISTINCT_SHARE_SAGA';
export const SHARE_DISTINCT_SAGA = 'SHARE_DISTINCT_SAGA';
export const GET_ASSESSEENODE_ASSESSEE_REVIEW_LIST = 'GET_ASSESSEENODE_ASSESSEE_REVIEW_LIST';
export const ASSESSEE_ASSOCIATE_LINK_LIST = 'ASSESSEE_ASSOCIATE_LINK_LIST';
export const ASSESSEE_ASSOCIATE_LINK_REVISE_SAGA = 'ASSESSEE_ASSOCIATE_LINK_REVISE_SAGA';
// associates SAGA
export const CREATE_ASSOCIATE_SAGA = 'CREATE_ASSOCIATE_SAGA'; //create associate
export const ASSOCIATE_REVIEW_DISTINCT_SAGA = 'ASSOCIATE_REVIEW_DISTINCT_SAGA';
export const ASSOCIATE_REVIEW_DISTINCT_SHARE_SAGA = 'ASSOCIATE_REVIEW_DISTINCT_SHARE_SAGA';
export const CREATE_ASSOCIATE_ROLE_SAGA = 'CREATE_ASSOCIATE_ROLE_SAGA';
export const GET_ASSOCIATE_TYPE_REVIEW_LIST_SAGA = 'GET_ASSOCIATE_TYPE_REVIEW_LIST_SAGA';
export const GET_ASSOCIATE_ROLE_REVIEW_LIST_SAGA = 'GET_ASSOCIATE_ROLE_REVIEW_LIST_SAGA';
export const GET_ASSIGNMENT_REFERENCE_LIST_SAGA = 'GET_ASSIGNMENT_REFERENCE_LIST_SAGA';
export const GET_ASSOCIATE_GROUP_REVIEW_LIST_SAGA = 'GET_ASSOCIATE_GROUP_REVIEW_LIST_SAGA';
export const GET_ASSOCIATEROLE_ASSOCIATE_REVIEW_LIST_SAGA =
  'GET_ASSOCIATEROLE_ASSOCIATE_REVIEW_LIST_SAGA';
export const GET_ASSOCIATETYPE_ASSOCIATE_REVIEW_LIST_SAGA =
  'GET_ASSOCIATETYPE_ASSOCIATE_REVIEW_LIST_SAGA';
export const GET_ASSOCIATEGROUP_ASSOCIATE_REVIEW_LIST_SAGA =
  'GET_ASSOCIATEGROUP_ASSOCIATE_REVIEW_LIST_SAGA';
export const CREATE_NODE_SAGA = 'CREATE_NODE_SAGA';
export const GET_ASSOCIATES_NODE_REVIEW_LIST_SAGA = 'GET_ASSOCIATES_NODE_REVIEW_LIST_SAGA';
export const GET_ASSIGNMENTTYPE_ASSIGNMENT_REVIEWLIST_SAGA =
  'GET_ASSIGNMENTTYPE_ASSIGNMENT_REVIEWLIST_SAGA';
export const INTERNAL_NODE_LIST_SAGA = 'INTERNAL_NODE_LIST_SAGA';
export const GROUP_CLASSIFICATION_LIST_SAGA = 'GROUP_CLASSIFICATION_LIST_SAGA';
export const ASSESSEE_MINE_ASSIGNMENT_LIST = 'ASSESSEE_MINE_ASSIGNMENT_LIST';
export const ASSESSEE_MINE_ASSIGNMENT_GROUP_LIST = 'ASSESSEE_MINE_ASSIGNMENT_GROUP_LIST';
export const GET_ASSESSEE_MINE_ASSIGNMENT_REVIEW_LIST = 'GET_ASSESSEE_MINE_ASSIGNMENT_REVIEW_LIST';
export const INTERNAL_NODE_LIST_WITH_PERMISSIONS_SAGA = 'INTERNAL_NODE_LIST_WITH_PERMISSIONS_SAGA';

//for assocaite information
export const UPDATE_ASSOCIATE_INFO = 'UPDATE_ASSOCIATE_INFO';
export const UPDATE_ASSOCIATE_WORKADDRESS_INFO = 'UPDATE_ASSOCIATE_WORKADDRESS_INFO';
export const UPDATE_ASSOCIATE_WORKTELEPHONE_INFO = 'UPDATE_ASSOCIATE_WORKTELEPHONE_INFO';
export const UPDATE_ASSOCIATE_WORKADDRESS_SECONDARY_INFO =
  'UPDATE_ASSOCIATE_WORKADDRESS_SECONDARY_INFO';
export const UPDATE_ASSOCIATE_BASIC_INFO = 'UPDATE_ASSOCIATE_BASIC_INFO';
export const UPDATE_ASSOCIATE_ADMIN_BASIC_INFO = 'UPDATE_ASSOCIATE_ADMIN_BASIC_INFO';
export const UPDATE_ASSOCIATE_ADMIN_MOBILE_INFO = 'UPDATE_ASSOCIATE_ADMIN_MOBILE_INFO';
export const UPDATE_ASSOCIATE_ADMIN_PERSONAL_INFO = 'UPDATE_ASSOCIATE_ADMIN_PERSONAL_INFO';
export const CLEAR_ASSOCIATE_INFO = 'CLEAR_ASSOCIATE_INFO';
export const ASSOCIATE_CREATE_INFO = 'ASSOCIATE_CREATE_INFO';
export const UPDATE_ASSOCIATE_SETUP_INFO = 'UPDATE_ASSOCIATE_SETUP_INFO';
export const UPDATE_ASSOCIATE_SETUP_ASSESSEE_INFO = 'UPDATE_ASSOCIATE_SETUP_ASSESSEE_INFO';
export const UPDATE_ASSOCIATE_SETUP_ASSESSMENT_INFO = 'UPDATE_ASSOCIATE_SETUP_ASSESSMENT_INFO';
export const UPDATE_ASSOCIATE_SETUP_ASSIGNMENT_INFO = 'UPDATE_ASSOCIATE_SETUP_ASSIGNMENT_INFO';
export const UPDATE_ASSOCIATE_SETUP_ITEM_INFO = 'UPDATE_ASSOCIATE_SETUP_ITEM_INFO';
export const UPDATE_ASSOCIATE_SETUP_ANALYTIC_INFO = 'UPDATE_ASSOCIATE_SETUP_ANALYTIC_INFO';
export const UPDATE_ASSOCIATE_SETUPPLUS_ASSESSEE_INFO = 'UPDATE_ASSOCIATE_SETUPPLUS_ASSESSEE_INFO';
export const UPDATE_ASSOCIATE_SETUPPLUS_ASSESSMENT_INFO =
  'UPDATE_ASSOCIATE_SETUPPLUS_ASSESSMENT_INFO';
export const UPDATE_ASSOCIATE_SETUPPLUS_ASSIGNMENT_INFO =
  'UPDATE_ASSOCIATE_SETUPPLUS_ASSIGNMENT_INFO';
export const UPDATE_ASSOCIATE_SETUPPLUS_INFO = 'UPDATE_ASSOCIATE_SETUPPLUS_INFO';
export const UPDATE_ASSOCIATE_SETUPPLUS_ITEM_INFO = 'UPDATE_ASSOCIATE_SETUPPLUS_ITEM_INFO';
export const UPDATE_ASSOCIATE_SETUPPLUS_ANALYTIC_INFO = 'UPDATE_ASSOCIATE_SETUPPLUS_ANALYTIC_INFO';
//setup reset
export const UPDATE_ASSOCIATE_SETUP_RESET_SAGA = 'UPDATE_ASSOCIATE_SETUP_RESET_SAGA';
// export const UPDATE_ASSOCIATE_SETUP_ASSESSEE_RESET = 'UPDATE_ASSOCIATE_SETUP_ASSESSEE_RESET';
// export const UPDATE_ASSOCIATE_SETUP_ASSESSMENT_RESET = 'UPDATE_ASSOCIATE_SETUP_ASSESSMENT_RESET';
// export const UPDATE_ASSOCIATE_SETUP_ASSIGNMENT_RESET = 'UPDATE_ASSOCIATE_SETUP_ASSIGNMENT_RESET';
// export const UPDATE_ASSOCIATE_SETUP_ITEM_RESET = 'UPDATE_ASSOCIATE_SETUP_ITEM_RESET';
// export const UPDATE_ASSOCIATE_SETUP_ANALYTIC_RESET = 'UPDATE_ASSOCIATE_SETUP_ANALYTIC_RESET';

export const UPDATE_ASSOCIATE_SETUP_ASSOCIATENODE_INFO =
  'UPDATE_ASSOCIATE_SETUP_ASSOCIATENODE_INFO';
export const UPDATE_ASSOCIATE_ASSOCIATENODE_INFO = 'UPDATE_ASSOCIATE_ASSOCIATENODE_INFO';
export const SET_IGURU_NODE_DYNAMIC_SINGLE_STATE = 'SET_IGURU_NODE_DYNAMIC_SINGLE_STATE';
export const SET_ASSOCIATE_INFORMATION = 'SET_ASSOCIATE_INFORMATION'; //create associate
export const SET_ASSOCIATE_DYNAMIC_SINGLE_STATE = 'SET_ASSOCIATE_DYNAMIC_SINGLE_STATE'; //create associate
//VARIABLES FOR CORE POPUP
export const NAMEPOPUP = 'NAMEPOPUP';
export const NAMEALIASPOPUP = 'NAMEALIASPOPUP';
export const ALIASPOPUP = 'ALIASPOPUP';
export const PICTUREPOPUP = 'PICTUREPOPUP';
export const MOBILETELEPHONEPOPUP = 'MOBILETELEPHONEPOPUP';
export const ASSOCIATEPICTUREPOPUP = 'ASSOCIATEPICTUREPOPUP';
export const EMAILPOPUP = 'EMAILPOPUP';
export const SINGLEDROPDOWNPOPUP = 'SINGLEDROPDOWNPOPUP';
export const HOMEADDRESSPOPUP = 'HOMEADDRESSPOPUP';
export const WORKADDRESSPOPUP = 'WORKADDRESSPOPUP';
export const CONFIRMATIONPOPUP = 'CONFIRMATIONPOPUP';
export const ASSOCIATECONFIRMATIONPOPUP = 'ASSOCIATECONFIRMATIONPOPUP';
export const DESCRIPTIONPOPUP = 'DESCRIPTIONPOPUP';
export const WORKTELEPHONE = 'WORKTELEPHONE';
export const ROLEPOPUP = 'ROLEPOPUP';
//for footer icon in middle pane
export const FILTERMODE = 'FILTERMODE';
export const NAVIGATOR_MODE = 'NAVIGATOR_MODE';
export const SET_FILTER_SINGLE_STATE = 'SET_FILTER_SINGLE_STATE';
export const FILTERMODE_ENABLE = 'FILTERMODE_ENABLE';
export const SET_REVIEW_LIST_RELATE_DATA = 'SET_REVIEW_LIST_RELATE_DATA';
//assessee assessment
export const SET_ASSESSEE_ASSESSMENT_DYNAMIC_STATE = 'SET_ASSESSEE_ASSESSMENT_DYNAMIC_STATE';
export const CLEAR_ASSESSEE_ASSESSMENT_REDUCER_STATE = 'CLEAR_ASSESSEE_ASSESSMENT_REDUCER_STATE';

// Assessees Module
export const ASSESSEE_POPUP_OPEN = 'ASSESSEE_POPUP_OPEN';
export const ASSESSEE_POPUP_CLOSE = 'ASSESSEE_POPUP_CLOSE';
export const SET_ASSESSEE_NEXT_POPUP = 'SET_ASSESSEE_NEXT_POPUP';
export const SET_ASSESSEE_PREVIOUS_POPUP = 'SET_ASSESSEE_PREVIOUS_POPUP';
export const SET_ASSESSEE_SECONDARY_OPTION_VALUE = 'SET_ASSESSEE_SECONDARY_OPTION_VALUE';
export const SET_ASSESSEE_SECONDARY_POPUP = 'SET_ASSESSEE_SECONDARY_POPUP';
export const GET_ASSESSEE_GROUP_REVIEW_INFO_SAGA = 'GET_ASSESSEE_GROUP_REVIEW_INFO_SAGA';
export const ASSESSEE_INFO_REVISE_SAGA = 'ASSESSEE_INFO_REVISE_SAGA';
export const ASSESSEE_ASSESSMENT_INFO_REVISE_STATUS_SAGA =
  'ASSESSEE_ASSESSMENT_INFO_REVISE_STATUS_SAGA';
export const GET_ASSESSEEGROUP_ASSESSEE_REVIEW_LIST = 'GET_ASSESSEEGROUP_ASSESSEE_REVIEW_LIST';
export const GET_ASSESSEEROLE_ASSESSEE_REVIEW_LIST = 'GET_ASSESSEEROLE_ASSESSEE_REVIEW_LIST';
export const GET_ASSESSEETYPE_ASSESSEE_REVIEW_LIST = 'GET_ASSESSEETYPE_ASSESSEE_REVIEW_LIST';
export const SET_ADMINISTRATOR_SECONDARY_LIST = 'SET_ADMINISTRATOR_SECONDARY_LIST';
export const SET_ASSIGNMENT_RELATED_LIST = 'SET_ASSIGNMENT_RELATED_LIST';
export const SET_ASSIGNMENT_RELATED_REVIEW_LIST = 'SET_ASSIGNMENT_RELATED_REVIEW_LIST';
export const RESET_ASSIGNMENT_REVIEW_LIST_OBJECT = 'RESET_ASSIGNMENT_REVIEW_LIST_OBJECT';
export const SET_WEIGHTAGE_SELECTED = 'SET_WEIGHTAGE_SELECTED';
export const SETJOB_WEIGHTAGE_SELECTED = 'SETJOB_WEIGHTAGE_SELECTED';
export const SET_RANGE_SELECTED = 'SET_RANGE_SELECTED';
export const ASSESSEE_GROUP_INFO_REVISE_SAGA = 'ASSESSEE_GROUP_INFO_REVISE_SAGA';
export const ASSESSEE_ROLE_INFO_REVISE_SAGA = 'ASSESSEE_ROLE_INFO_REVISE_SAGA';
export const SET_ASSESSEE_ROLE_ASSESSEE_ID_LIST = 'SET_ASSESSEE_ROLE_ASSESSEE_ID_LIST';
export const SET_CREATE_MODE = 'SET_CREATE_MODE';
export const SET_PANE_THREE_PREVIEW_MODE = 'SET_PANE_THREE_PREVIEW_MODE';
export const SET_PANE_THREE_ITEM_PREVIEW_MODE = 'SET_PANE_THREE_ITEM_PREVIEW_MODE';
export const SET_ASSOCIATE_NODE_ASSESSEE_ID_LIST = 'SET_ASSOCIATE_NODE_ASSESSEE_ID_LIST';
export const SET_UNSELECTED_ASSESSEE_ROLE_ASSESSEE_ID_LIST =
  'SET_UNSELECTED_ASSESSEE_ROLE_ASSESSEE_ID_LIST';
export const SET_UNSELECTED_ASSOCIATE_NODE_ASSESSEE_ID_LIST =
  'SET_UNSELECTED_ASSOCIATE_NODE_ASSESSEE_ID_LIST';
export const SET_ASSESSEE_GROUP_ASSESSEE_ID_LIST = 'SET_ASSESSEE_GROUP_ASSESSEE_ID_LIST';
export const SET_UNSELECTED_ASSESSEE_GROUP_ASSESSEE_ID_LIST =
  'SET_UNSELECTED_ASSESSEE_GROUP_ASSESSEE_ID_LIST';
export const SET_STATUS_POPUP_VALUE = 'SET_STATUS_POPUP_VALUE';
export const GET_ASSESSEE_TYPE_REVIEW_INFO_SAGA = 'GET_ASSESSEE_TYPE_REVIEW_INFO_SAGA';
export const ASSESSEE_TYPE_INFO_REVISE_SAGA = 'ASSESSEE_TYPE_INFO_REVISE_SAGA';
export const ASSESSEE_ASSESSMENT_START_SAGA = 'ASSESSEE_ASSESSMENT_START_SAGA';
export const ASSESSEE_ALLOCATE_GRP_SAGA = 'ASSESSEE_ALLOCATE_GRP_SAGA';
export const ITEM_ALLOCATE_SAGA = 'ITEM_ALLOCATE_SAGA';
export const ITEM_ALLOCATE_ASSESSMENT_SAGA = 'ITEM_ALLOCATE_ASSESSMENT_SAGA';
export const ASSESSEE_SIGN_ON_EMAILCHECK_SAGA = 'ASSESSEE_SIGN_ON_EMAILCHECK_SAGA';

// Associates Module
export const ASSOCIATE_POPUP_OPEN = 'ASSOCIATE_POPUP_OPEN';
export const ASSOCIATE_POPUP_CLOSE = 'ASSOCIATE_POPUP_CLOSE';
export const SET_ASSOCIATE_NEXT_POPUP = 'SET_ASSOCIATE_NEXT_POPUP';
export const SET_ASSOCIATE_SECONDARY_POPUP = 'SET_ASSOCIATE_SECONDARY_POPUP';
export const SET_ASSOCIATE_PREVIOUS_POPUP = 'SET_ASSOCIATE_PREVIOUS_POPUP';
export const SET_ASSOCIATE_SECONDARY_OPTION_VALUE = 'SET_ASSOCIATE_SECONDARY_OPTION_VALUE';
export const GET_ASSOCIATE_GROUP_REVIEW_INFO_SAGA = 'GET_ASSOCIATE_GROUP_REVIEW_INFO_SAGA';
export const ASSOCIATE_INFO_REVISE_SAGA = 'ASSOCIATE_INFO_REVISE_SAGA';
export const ASSOCIATE_ASSESSEESETUP_REVISE_SAGA = 'ASSOCIATE_ASSESSEESETUP_REVISE_SAGA';
export const ASSOCIATE_ASSESSMENTSETUP_REVISE_SAGA = 'ASSOCIATE_ASSESSMENTSETUP_REVISE_SAGA';
export const ASSOCIATE_ASSOCIATESETUP_REVISE_SAGA = 'ASSOCIATE_ASSOCIATESETUP_REVISE_SAGA';
export const ASSOCIATE_ASSIGNMENTSETUP_REVISE_SAGA = 'ASSOCIATE_ASSIGNMENTSETUP_REVISE_SAGA';
export const ASSOCIATE_ASSOCIATENODE_SETUP_REVISE_SAGA =
  'ASSOCIATE_ASSOCIATENODE_SETUP_REVISE_SAGA';
export const ASSOCIATE_ITEMSETUP_REVISE_SAGA = 'ASSOCIATE_ITEMSETUP_REVISE_SAGA';
export const ASSOCIATE_ANALYTICSETUP_REVISE_SAGA = 'ASSOCIATE_ANALYTICSETUP_REVISE_SAGA';
export const ASSOCIATE_SETUP_SAGA = 'ASSOCIATE_SETUP_SAGA';
export const ASSOCIATE_ANALYTIC_SETUP_SAGA = 'ASSOCIATE_ANALYTIC_SETUP_SAGA';
export const ASSOCIATE_ITEM_SETUP_SAGA = 'ASSOCIATE_ITEM_SETUP_SAGA';
export const ASSOCIATE_NODE_SETUP_SAGA = 'ASSOCIATE_NODE_SETUP_SAGA';
export const ASSOCIATE_ASSESSMENT_SETUP_SAGA = 'ASSOCIATE_ASSESSMENT_SETUP_SAGA';
export const ASSOCIATE_ASSIGNMENT_SETUP_SAGA = 'ASSOCIATE_ASSIGNMENT_SETUP_SAGA';
export const ASSOCIATE_ASSESSESS_SETUP_SAGA = 'ASSOCIATE_ASSESSESS_SETUP_SAGA';
export const ASSOCIATE_ASSESSESS_SIGNON_SETUP_SAGA = 'ASSOCIATE_ASSESSESS_SIGNON_SETUP_SAGA';
export const ASSOCIATE_GROUP_REVISE_INFO_SAGA = 'ASSOCIATE_GROUP_REVISE_INFO_SAGA';
export const ASSOCIATE_ROLE_REVISE_INFO_SAGA = 'ASSOCIATE_ROLE_REVISE_INFO_SAGA';
export const ASSOCIATE_NODE_INFO_REVISE_SAGA = 'ASSOCIATE_NODE_INFO_REVISE_SAGA';
export const GET_ASSOCIATE_NODE_REVIEW_INFO_SAGA = 'GET_ASSOCIATE_NODE_REVIEW_INFO_SAGA';
export const GET_ASSOCIATE_TYPE_REVIEW_INFO_SAGA = 'GET_ASSOCIATE_TYPE_REVIEW_INFO_SAGA';
export const ASSOCIATE_TYPE_INFO_REVISE_SAGA = 'ASSOCIATE_TYPE_INFO_REVISE_SAGA';
export const GET_NODE_ASSOCIATE_REVIEW_LIST = 'GET_NODE_ASSOCIATE_REVIEW_LIST';
export const ASSOCIATE_ALLOCATE_SAGA = 'ASSOCIATE_ALLOCATE_SAGA';
export const UPDATE_ASSOCIATE_COUNTRY_INFO = 'UPDATE_ASSOCIATE_COUNTRY_INFO';
export const UPDATE_ASSOCIATE_CURRENCY_INFO = 'UPDATE_ASSOCIATE_CURRENCY_INFO';
export const UPDATE_ASSOCIATE_LANGUAGE_INFO = 'UPDATE_ASSOCIATE_LANGUAGE_INFO';
export const ASSOCIATE_SIGN_ON_ASSIGNMENT_LIST_SAGA = 'ASSOCIATE_SIGN_ON_ASSIGNMENT_LIST_SAGA';
// Assessment Module
export const ASSESSMENT_POPUP_OPEN = 'ASSESSMENT_POPUP_OPEN';
export const CLOSE_ASSESSMENT_POPUP_OPEN = 'CLOSE_ASSESSMENT_POPUP_OPEN';
export const SET_ASSESSMENT_SINGLE_STATE = 'SET_ASSESSMENT_SINGLE_STATE';
export const ASSESSMENT_ALLOCATE_GRP_SAGA = 'ASSESSMENT_ALLOCATE_GRP_SAGA';
export const ASSESSMENT_POPUP_CLOSE = 'ASSESSMENT_POPUP_CLOSE';
export const ASSESSMENT_ALLOCATE_SAGA = 'ASSESSMENT_ALLOCATE_SAGA';
export const SET_ASSESSMENT_NEXT_POPUP = 'SET_ASSESSMENT_NEXT_POPUP';
export const SET_ASSESSMENT_PREVIOUS_POPUP = 'SET_ASSESSMENT_PREVIOUS_POPUP';
export const CLEAR_ASSESSMENT_INFO = 'CLEAR_ASSESSMENT_INFO';
export const SET_ASSESSMENT_FRAMEWORK_STATE = 'SET_ASSESSMENT_FRAMEWORK_STATE';
export const SET_ASSESSMENT_DYNAMIC_FRAMEWORK_STATE = 'SET_ASSESSMENT_DYNAMIC_FRAMEWORK_STATE';
export const SET_ITEMFRAMEWORK_REDUCER_STATE = 'SET_ITEMFRAMEWORK_REDUCER_STATE';
export const SET_ASSESSMENT_COMMUNIQUE_FRAMEWORK_STATE =
  'SET_ASSESSMENT_COMMUNIQUE_FRAMEWORK_STATE';
export const SET_ASSESSMENT_MANUSCRIPT_FRAMEWORK_STATE =
  'SET_ASSESSMENT_MANUSCRIPT_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SYNOPSIS_FRAMEWORK_STATE = 'SET_ASSESSMENT_SYNOPSIS_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SCORE_FRAMEWORK_STATE = 'SET_ASSESSMENT_SCORE_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SECONDARY_OPTION_VALUE = 'SET_ASSESSMENT_SECONDARY_OPTION_VALUE';
export const SET_ASSESSMENT_SECONDARY_POPUP = 'SET_ASSESSMENT_SECONDARY_POPUP';
export const GET_ASSESSMENT_GROUP_REVIEW_INFO_SAGA = 'GET_ASSESSMENT_GROUP_REVIEW_INFO_SAGA';
export const ASSESSMENT_GROUP_REVISE_INFO_SAGA = 'ASSESSMENT_GROUP_REVISE_INFO_SAGA';
export const ITEM_GROUP_REVISE_INFO_SAGA = 'ITEM_GROUP_REVISE_INFO_SAGA';
export const GET_ITEM_GROUP_REVIEW_INFO_SAGA = 'GET_ITEM_GROUP_REVIEW_INFO_SAGA';
export const GET_ASSESSMENT_TYPE_REVIEW_INFO_SAGA = 'GET_ASSESSMENT_TYPE_REVIEW_INFO_SAGA';
export const GET_ITEM_TYPE_REVIEW_INFO_SAGA = 'GET_ITEM_TYPE_REVIEW_INFO_SAGA';
export const ITEM_TYPE_REVISE_INFO_SAGA = 'ITEM_TYPE_REVISE_INFO_SAGA';
export const ASSESSMENT_TYPE_REVISE_INFO_SAGA = 'ASSESSMENT_TYPE_REVISE_INFO_SAGA';
export const GET_ASSESSMENT_INFO_SAGA = 'GET_ASSESSMENT_INFO_SAGA';
export const GET_ASSIGNMENT_ASSESSMENT_INFO_SAGA = 'GET_ASSIGNMENT_ASSESSMENT_INFO_SAGA';
export const GET_ASSESSMENT_SEC_INFO_SAGA = 'GET_ASSESSMENT_SEC_INFO_SAGA';
export const SET_ASSESSMENT_REDUCER_STATE = 'SET_ASSESSMENT_REDUCER_STATE';
export const SET_ASSESSMENT_BASIC_REDUCER_STATE = 'SET_ASSESSMENT_BASIC_REDUCER_STATE';
export const SET_ASSESSMENT_DYNAMIC_SINGLE_STATE = 'SET_ASSESSMENT_DYNAMIC_SINGLE_STATE';
export const ASSESSMENT_INFO_REVISE_SAGA = 'ASSESSMENT_INFO_REVISE_SAGA';
export const ASSESSMENT_REVISE_SAGA = 'ASSESSMENT_REVISE_SAGA';
export const ASSESSMENT_CLUSTER_REVISE_SAGA = 'ASSESSMENT_CLUSTER_REVISE_SAGA';
export const ASSESSMENT_PUBLISH_SAGA = 'ASSESSMENT_PUBLISH_SAGA';
export const GET_ITEM_INFO_SAGA = 'GET_ITEM_INFO_SAGA';
export const ITEM_INFO_REVISE_SAGA = 'ITEM_INFO_REVISE_SAGA';
export const ITEM_MULTI_STATUS_REVISE_SAGA = 'ITEM_MULTI_STATUS_REVISE_SAGA';
export const GET_ITEM_TYPE_REVIEW_LIST_SAGA = 'GET_ITEM_TYPE_REVIEW_LIST_SAGA';
export const GET_FRAMWORK_TYPE_REVIEW_LIST_SAGA = 'GET_FRAMWORK_TYPE_REVIEW_LIST_SAGA';
export const GET_ITEMGROUPITEM_REVIEW_LIST_SAGA = 'GET_ITEMGROUPITEM_REVIEW_LIST_SAGA';
export const GET_ITEMTYPEITEM_REVIEW_LIST_SAGA = 'GET_ITEMTYPEITEM_REVIEW_LIST_SAGA';
export const SET_ITEM_DYNAMIC_SINGLE_STATE = 'SET_ITEM_DYNAMIC_SINGLE_STATE';
export const SET_ITEM_FRAMEWORK_DYNAMIC_SINGLE_STATE = 'SET_ITEM_FRAMEWORK_DYNAMIC_SINGLE_STATE';
export const SET_ITEM_SUB_ITEM_DYNAMIC_SINGLE_STATE = 'SET_ITEM_SUB_ITEM_DYNAMIC_SINGLE_STATE';
export const SET_ITEM_FRAMEWORK_INNER_SINGLE_STATE = 'SET_ITEM_FRAMEWORK_INNER_SINGLE_STATE';
export const ADD_ITEM_OPTION_OBJECT = 'ADD_ITEM_OPTION_OBJECT';
export const REMOVE_ITEM_OPTION_OBJECT = 'REMOVE_ITEM_OPTION_OBJECT';
export const SET_CULTURE_DYNAMIC_SINGLE_STATE = 'SET_CULTURE_DYNAMIC_SINGLE_STATE';
export const SET_JOB_DYNAMIC_SINGLE_STATE = 'SET_JOB_DYNAMIC_SINGLE_STATE';
export const SET_JOB_DYNAMIC_ARRAY_STATE = 'SET_JOB_DYNAMIC_ARRAY_STATE';
export const GET_NODE_ASSESSMENTS_REVIEW_LIST_SAGA = 'GET_NODE_ASSESSMENTS_REVIEW_LIST_SAGA';
export const GET_ASSESSMENT_ITEM_REVIEW_LIST_SAGA = 'GET_ASSESSMENT_ITEM_REVIEW_LIST_SAGA';
export const GET_ASSESSMENTTYPE_ASSESSMENT_REVIEWLIST_SAGA =
  'GET_ASSESSMENTTYPE_ASSESSMENT_REVIEWLIST_SAGA';
export const GET_ASSESSMENTGROUP_ASSESSMENT_REVIEWLIST_SAGA =
  'GET_ASSESSMENTGROUP_ASSESSMENT_REVIEWLIST_SAGA';
export const SET_ASSESSMENT_AID_FRAMEWORK_STATE = 'SET_ASSESSMENT_AID_FRAMEWORK_STATE';
export const SET_ASSESSMENT_EVALUATION_FRAMEWORK_STATE =
  'SET_ASSESSMENT_EVALUATION_FRAMEWORK_STATE';
export const SET_PANE_THREE_ASSESSMENT_PREVIEW_MODE = 'SET_PANE_THREE_ASSESSMENT_PREVIEW_MODE';
export const ASSESSMENT_PREVIEW_REVISE_SAGA = 'ASSESSMENT_PREVIEW_REVISE_SAGA';
export const ASSESSMENT_INFO_PREVIEW_SAGA = 'ASSESSMENT_INFO_PREVIEW_SAGA';
export const SET_ASSESSMENT_TEMPLATE_FRAMEWORK_STATE = 'SET_ASSESSMENT_TEMPLATE_FRAMEWORK_STATE';
export const SET_ASSESSMENT_FRAMEWORK_TIMELINE_STATE = 'SET_ASSESSMENT_FRAMEWORK_TIMELINE_STATE';

// Assignments Module
export const ASSIGNMENT_POPUP_OPEN = 'ASSIGNMENT_POPUP_OPEN';
export const ASSIGNMENT_POPUP_CLOSE = 'ASSIGNMENT_POPUP_CLOSE';
export const IGAUGE_SECTION_POPUP_CLOSE = 'IGAUGE_SECTION_POPUP_CLOSE';
export const SET_ASSIGNMENT_SINGLE_STATE = 'SET_ASSIGNMENT_SINGLE_STATE';
export const ASSIGNMENT_ALLOCATE_SAGA = 'ASSIGNMENT_ALLOCATE_SAGA';
export const SET_ASSIGNMENT_NEXT_POPUP = 'SET_ASSIGNMENT_NEXT_POPUP';
export const SET_ASSIGNMENT_PREVIOUS_POPUP = 'SET_ASSIGNMENT_PREVIOUS_POPUP';
export const CLEAR_ASSIGNMENT_INFO = 'CLEAR_ASSIGNMENT_INFO';
export const SET_ASSIGNMENT_SECONDARY_POPUP = 'SET_ASSIGNMENT_SECONDARY_POPUP';
export const SET_ASSIGNMENT_SECONDARY_OPTION_VALUE = 'SET_ASSIGNMENT_SECONDARY_OPTION_VALUE';
export const GET_ASSIGNMENT_GROUP_REVIEW_INFO_SAGA = 'GET_ASSIGNMENT_GROUP_REVIEW_INFO_SAGA';
export const GET_ASSIGNMENT_TYPE_REVIEW_INFO_SAGA = 'GET_ASSIGNMENT_TYPE_REVIEW_INFO_SAGA';
export const ASSIGNMENT_TYPE_REVISE_INFO_SAGA = 'ASSIGNMENT_TYPE_REVISE_INFO_SAGA';
export const SET_ASSIGNMENT_BASIC_REDUCER_STATE = 'SET_ASSIGNMENT_BASIC_REDUCER_STATE';
export const GET_ASSIGNMENT_INFO_SAGA = 'GET_ASSIGNMENT_INFO_SAGA';
export const SET_ASSIGNMENT_DYNAMIC_SINGLE_STATE = 'SET_ASSIGNMENT_DYNAMIC_SINGLE_STATE';
export const SET_ASSIGNMENT_FRAMEWORK_STATE = 'SET_ASSIGNMENT_FRAMEWORK_STATE';
export const SET_ASSIGNMENT_COMMUNIQUE_FRAMEWORK_STATE =
  'SET_ASSIGNMENT_COMMUNIQUE_FRAMEWORK_STATE';
export const SET_ASSIGNMENT_SYNOPSIS_FRAMEWORK_STATE = 'SET_ASSIGNMENT_SYNOPSIS_FRAMEWORK_STATE';
export const ASSIGNMENT_INFO_REVISE_SAGA = 'ASSIGNMENT_INFO_REVISE_SAGA';
export const ASSIGNMENT_REVISE_SAGA = 'ASSIGNMENT_REVISE_SAGA';
export const ASSIGNMENT_GROUP_REVISE_INFO_SAGA = 'ASSIGNMENT_GROUP_REVISE_INFO_SAGA';
export const ASSIGNMENT_PUBLISH_SAGA = 'ASSIGNMENT_PUBLISH_SAGA';
export const GET_ASSIGNMENTGROUP_ASSIGNMENT_REVIEWLIST_SAGA =
  'GET_ASSIGNMENTGROUP_ASSIGNMENT_REVIEWLIST_SAGA';
export const GET_ASSIGNMENTDISTINCT_ASSESSEES_REVIEWLIST_SAGA =
  'GET_ASSIGNMENTDISTINCT_ASSESSEES_REVIEWLIST_SAGA';
export const GET_ASSIGNMENTDISTINCT_ASSESSMENT_REVIEWLIST_SAGA =
  'GET_ASSIGNMENTDISTINCT_ASSESSMENT_REVIEWLIST_SAGA';
export const GET_ASSIGNMENTDISTINCT_CULTURE_PROFILE_REVIEWLIST_SAGA =
  'GET_ASSIGNMENTDISTINCT_CULTURE_PROFILE_REVIEWLIST_SAGA';
export const GET_ASSIGNMENTDISTINCT_JOB_PROFILE_REVIEWLIST_SAGA =
  'GET_ASSIGNMENTDISTINCT_JOB_PROFILE_REVIEWLIST_SAGA';
export const GET_NODE_ASSIGNMENTS_REVIEW_LIST_SAGA = 'GET_NODE_ASSIGNMENTS_REVIEW_LIST_SAGA';
export const ASSESSEE_ALLOCATE_ASSIGNMENT_SAGA = 'ASSESSEE_ALLOCATE_ASSIGNMENT_SAGA';
export const ASSESSMENT_ALLOCATE_ASSIGNMENT_SAGA = 'ASSESSMENT_ALLOCATE_ASSIGNMENT_SAGA';
export const SET_ASSIGNMENT_DYNAMIC_SETUP_STATE = 'SET_ASSIGNMENT_DYNAMIC_SETUP_STATE';

// Section PopUps
export const SECTION_POPUP_OPEN = 'SECTION_POPUP_OPEN';
export const SET_SECTION_HEADER_ONE = 'SET_SECTION_HEADER_ONE';
export const SET_SECTION_HEADER_ONE_BADGE_ONE = 'SET_SECTION_HEADER_ONE_BADGE_ONE';
export const SET_IGAUGE_SECTION_POPUP_SINGLE_STATE = 'SET_IGAUGE_SECTION_POPUP_SINGLE_STATE';
export const SET_SECTION_TWO_SECONDARY_OPTION_VALUE = 'SET_SECTION_TWO_SECONDARY_OPTION_VALUE';
export const CLEAR_IGAUGE_REDUCER = 'CLEAR_IGAUGE_REDUCER';
export const SECTION_POPUP_CLOSE = 'SECTION_POPUP_CLOSE';
export const SET_PREVIOUS_SECTION_POPUP = 'SET_PREVIOUS_SECTION_POPUP';

// displayPaneThree
export const SET_DISPLAY_PANE_THREE_STATE = 'SET_DISPLAY_PANE_THREE_STATE';
export const GET_ASSESSEE_INFO_SAGA = 'GET_ASSESSEE_INFO_SAGA';
export const CLEAR_DISPLAY_PANE_THREE = 'CLEAR_DISPLAY_PANE_THREE';
export const GET_ASSOCIATE_INFO_SAGA = 'GET_ASSOCIATE_INFO_SAGA';
export const SET_DISPLAY_PANE_THREE_REVIEW_MODE = 'SET_DISPLAY_PANE_THREE_REVIEW_MODE';

// cultur
//assesseeAssignmnet
export const GET_ASSESSEE_ASSIGNMENT_SAGA = 'GET_ASSESSEE_ASSIGNMENT_SAGA';
export const GET_ASSESSEE_ASSIGNMENT_REIEW_SAGA = 'GET_ASSESSEE_ASSIGNMENT_REIEW_SAGA';
export const UPDATE_ASSESSEE_MINE_ASSIGNMENTS = 'UPDATE_ASSESSEE_MINE_ASSIGNMENTS';
//assesseeAssignmnet
export const CREATE_CULTURE_SAGA = 'CREATE_CULTURE_SAGA';
export const GET_CULTUREPROFILE_REVIEW_LIST_SAGA = 'GET_CULTUREPROFILE_REVIEW_LIST_SAGA';
export const GET_CULTUREPROFILE_GROUP_REVIEW_LIST_SAGA =
  'GET_CULTUREPROFILE_GROUP_REVIEW_LIST_SAGA';
export const GET_CULTUREPROFILE_TYPE_REVIEW_LIST_SAGA = 'GET_CULTUREPROFILE_TYPE_REVIEW_LIST_SAGA';
export const CULTURE_GROUP_REVISE_INFO_SAGA = 'CULTURE_GROUP_REVISE_INFO_SAGA';
export const GET_CULTURE_GROUP_REVIEW_INFO_SAGA = 'GET_CULTURE_GROUP_REVIEW_INFO_SAGA';
export const CULTURE_TYPE_REVISE_INFO_SAGA = 'CULTURE_TYPE_REVISE_INFO_SAGA';
export const GET_CULTURE_TYPE_REVIEW_INFO_SAGA = 'GET_CULTURE_TYPE_REVIEW_INFO_SAGA';
export const SET_CULTURE_TYPE_REDUCER_STATE = 'SET_CULTURE_TYPE_REDUCER_STATE';
export const CULTURE_GROUP_CULTURE_REVIEWLIST_SAGA = 'CULTURE_GROUP_CULTURE_REVIEWLIST_SAGA';
export const CULTURE_TYPE_CULTURE_REVIEWLIST_SAGA = 'CULTURE_TYPE_CULTURE_REVIEWLIST_SAGA';
export const CULTURE_ASSESSMENTS_REVIEWLIST_SAGA = 'CULTURE_ASSESSMENTS_REVIEWLIST_SAGA';
export const GET_ALLOCATE_CULTURE = 'GET_ALLOCATE_CULTURE';
export const GET_ALLOCATE_CULTURE_GROUP = 'GET_ALLOCATE_CULTURE_GROUP';
export const CULTUREPROFILE_ALLOCATE_SAGA = 'CULTUREPROFILE_ALLOCATE_SAGA';
export const CULTUREPROFILE_ALLOCATE_ASSIGNMENT_SAGA = 'CULTUREPROFILE_ALLOCATE_ASSIGNMENT_SAGA';
export const GET_CULTURE_NODE_CULTURE_REVIEW_LIST_SAGA =
  'GET_CULTURE_NODE_CULTURE_REVIEW_LIST_SAGA';

//job

export const CREATE_JOB_SAGA = 'CREATE_JOB_SAGA';
export const GET_JOBPROFILE_GROUP_REVIEW_LIST_SAGA = 'GET_JOBPROFILE_GROUP_REVIEW_LIST_SAGA';
export const GET_JOBPROFILE_REVIEW_LIST_SAGA = 'GET_JOBPROFILE_REVIEW_LIST_SAGA';
export const GET_JOBPROFILE_TYPE_REVIEW_LIST_SAGA = 'GET_JOBPROFILE_TYPE_REVIEW_LIST_SAGA';
export const JOB_GROUP_REVISE_INFO_SAGA = 'JOB_GROUP_REVISE_INFO_SAGA';
export const GET_JOB_GROUP_REVIEW_INFO_SAGA = 'GET_JOB_GROUP_REVIEW_INFO_SAGA';
export const JOB_TYPE_REVISE_INFO_SAGA = 'JOB_TYPE_REVISE_INFO_SAGA';
export const GET_JOB_TYPE_REVIEW_INFO_SAGA = 'GET_JOB_TYPE_REVIEW_INFO_SAGA';
export const SET_JOB_TYPE_REDUCER_STATE = 'SET_JOB_TYPE_REDUCER_STATE';
export const JOB_GROUP_JOB_REVIEWLIST_SAGA = 'JOB_GROUP_JOB_REVIEWLIST_SAGA';
export const JOB_TYPE_JOB_REVIEWLIST_SAGA = 'JOB_TYPE_JOB_REVIEWLIST_SAGA';
export const GET_ALLOCATE_JOB = 'GET_ALLOCATE_JOB';
export const GET_ALLOCATE_JOB_GROUP = 'GET_ALLOCATE_JOB_GROUP';
export const GET_JOB_NODE_JOB_REVIEW_LIST_SAGA = 'GET_JOB_NODE_JOB_REVIEW_LIST_SAGA';
export const GET_JOBDOMAIN_REVIEW_LIST_SAGA = 'GET_JOBDOMAIN_REVIEW_LIST_SAGA';
export const GET_JOBFUNCTION_REVIEW_LIST_SAGA = 'GET_JOBFUNCTION_REVIEW_LIST_SAGA';
export const GET_JOBROLE_REVIEW_LIST_SAGA = 'GET_JOBROLE_REVIEW_LIST_SAGA';
export const JOB_ASSESSMENTS_REVIEWLIST_SAGA = 'JOB_ASSESSMENTS_REVIEWLIST_SAGA';
export const SET_JOB_COMPETANCY_STATE = 'SET_JOB_COMPETANCY_STATE';
export const SET_JOB_SIFTLIST_STATE = 'SET_JOB_SIFTLIST_STATE';
export const SET_WEIGHTAGE_JOB_PROFILE = 'SET_WEIGHTAGE_JOB_PROFILE';
export const SET_JOB_COMPETENCY_WEIGHTAGE_LIST = 'SET_JOB_COMPETENCY_WEIGHTAGE_LIST';
export const SET_JOB_COMPETENCY_RANGE_LIST = 'SET_JOB_COMPETENCY_RANGE_LIST';
export const JOBPROFILE_ALLOCATE_SAGA = 'JOBPROFILE_ALLOCATE_SAGA';
export const JOBPROFILE_ALLOCATE_ASSIGNMENT_SAGA = 'JOBPROFILE_ALLOCATE_ASSIGNMENT_SAGA';
export const JOB_PROFILE_MULTI_STATUS_REVISE_SAGA = 'JOB_PROFILE_MULTI_STATUS_REVISE_SAGA';
export const JOB_PROFILE_PUBLISHED_SAGA = 'JOB_PROFILE_PUBLISHED_SAGA';
//item_config - Item_TYPE
export const CONFIG_ITEM_ROLE_TYPE = 'CONFIG_ITEM_ROLE_TYPE';

export const SET_ASSESSEE_ASSESSMENT_RESULT = 'SET_ASSESSEE_ASSESSMENT_RESULT';
// cluster
export const SET_CLUSTER_REDUCER_STATE = 'SET_CLUSTER_REDUCER_STATE';
export const CLEAR_CLUSTER_REDUCER_STATE = 'CLEAR_CLUSTER_REDUCER_STATE';
// version
export const SET_VERSION_REDUCER_STATE = 'SET_VERSION_REDUCER_STATE';
export const CLEAR_VERSION_REDUCER_STATE = 'CLEAR_VERSION_REDUCER_STATE';
// norm
export const SET_NORM_REDUCER_STATE = 'SET_NORM_REDUCER_STATE';
export const CLEAR_NORM_REDUCER_STATE = 'CLEAR_NORM_REDUCER_STATE';
// norm
export const SET_SCORE_REDUCER_STATE = 'SET_SCORE_REDUCER_STATE';
export const CLEAR_SCORE_REDUCER_STATE = 'CLEAR_SCORE_REDUCER_STATE';
// section
export const SET_SECTION_REDUCER_STATE = 'SET_SECTION_REDUCER_STATE';
export const CLEAR_SECTION_REDUCER_STATE = 'CLEAR_SECTION_REDUCER_STATE';
// scales
export const SET_SCALE_REDUCER_STATE = 'SET_SCALE_REDUCER_STATE';
export const CLEAR_SCALE_REDUCER_STATE = 'CLEAR_SCALE_REDUCER_STATE';
export const SET_SCALE_INFO_REDUCER_STATE = 'SET_SCALE_INFO_REDUCER_STATE';
// grades
export const SET_GRADE_REDUCER_STATE = 'SET_GRADE_REDUCER_STATE';
export const CLEAR_GRADE_REDUCER_STATE = 'CLEAR_GRADE_REDUCER_STATE';
export const SET_GRADE_SCORE_STATE = 'SET_GRADE_SCORE_STATE';
// scales
export const SET_GUAGE_REDUCER_STATE = 'SET_GUAGE_REDUCER_STATE';
export const CLEAR_GUAGE_REDUCER_STATE = 'CLEAR_GUAGE_REDUCER_STATE';
export const SET_GUAGE_INFO_REDUCER_STATE = 'SET_GUAGE_INFO_REDUCER_STATE';

export const SET_ASSESSMENT_FRAMEWORK_INNER_SINGLE_STATE =
  'SET_ASSESSMENT_FRAMEWORK_INNER_SINGLE_STATE';
export const SET_ASSESSMENT_FRAMEWORK_DYNAMIC_SINGLE_STATE =
  'SET_ASSESSMENT_FRAMEWORK_DYNAMIC_SINGLE_STATE';
export const SET_ASSESSMENT_REVISE_DYNAMIC_SINGLE_STATE =
  'SET_ASSESSMENT_REVISE_DYNAMIC_SINGLE_STATE';
export const SET_PANE_THREE_ASSESSMENT_SECTION_PREVIEW_MODE =
  'SET_PANE_THREE_ASSESSMENT_SECTION_PREVIEW_MODE';
export const SET_PANE_THREE_ASSESSMENT_VERSION_PREVIEW_MODE =
  'SET_PANE_THREE_ASSESSMENT_VERSION_PREVIEW_MODE';
export const SET_ASSESSMENT_SECTION_AID_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_AID_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SECTION_SCORE_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_SCORE_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SECTION_RESPONCE_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_RESPONCE_FRAMEWORK_STATE';

export const SET_ASSESSMENT_SECTION_COMMUNIQUE_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_COMMUNIQUE_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SECTION_MANUSCRIPT_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_MANUSCRIPT_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SECTION_SYNOPSIS_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_SYNOPSIS_FRAMEWORK_STATE';
export const SET_ASSESSMENT_SECTION_FRAMEWORK_DYNAMIC_SINGLE_STATE =
  'SET_ASSESSMENT_SECTION_FRAMEWORK_DYNAMIC_SINGLE_STATE';
export const SET_ASSESSMENT_SECTION_DYNAMIC_FRAMEWORK_STATE =
  'SET_ASSESSMENT_SECTION_DYNAMIC_FRAMEWORK_STATE';
export const SET_ASSESSEE_ASSESSMENT_ISASSESSMENTSTART_STATE =
  'SET_ASSESSEE_ASSESSMENT_ISASSESSMENTSTART_STATE';
export const SET_ASSESSEE_ASSESSMENT_COMMUNIQUE_STATE = 'SET_ASSESSEE_ASSESSMENT_COMMUNIQUE_STATE';
export const SET_ASSESSEE_ASSESSMENT_MENUSCRIPT_STATE = 'SET_ASSESSEE_ASSESSMENT_MENUSCRIPT_STATE';
export const SET_ASSESSEE_ASSESSMENT_SYNOPSIS_STATE = 'SET_ASSESSEE_ASSESSMENT_SYNOPSIS_STATE';
export const SET_ASSESSEE_ASSESSMENT_SECTION_COMMUNIQUE_STATE =
  'SET_ASSESSEE_ASSESSMENT_SECTION_COMMUNIQUE_STATE';
export const SET_ASSESSEE_ASSESSMENT_SECTION_MENUSCRIPT_STATE =
  'SET_ASSESSEE_ASSESSMENT_SECTION_MENUSCRIPT_STATE';
export const SET_ASSESSEE_ASSESSMENT_SECTION_SYNOPSIS_STATE =
  'SET_ASSESSEE_ASSESSMENT_SECTION_SYNOPSIS_STATE';
export const SET_ASSESSEE_ASSESSMENT_ITEM_LAST_ATTEMPT_SAGA =
  'SET_ASSESSEE_ASSESSMENT_ITEM_LAST_ATTEMPT_SAGA';
export const SET_ASSESSMENT_ADMINISTRATOR_FRAMEWORK_STATE =
  'SET_ASSESSMENT_ADMINISTRATOR_FRAMEWORK_STATE';
export const ASSIGNMENT_ASSESSMENT_INFO_REVISE_SAGA = 'ASSIGNMENT_ASSESSMENT_INFO_REVISE_SAGA';
export const ASSESSEE_MULTI_STATUS_REVISE_SAGA = 'ASSESSEE_MULTI_STATUS_REVISE_SAGA';
export const ASSIGNMENT_MULTI_STATUS_REVISE_SAGA = 'ASSIGNMENT_MULTI_STATUS_REVISE_SAGA';
export const ASSOCIATE_MULTI_STATUS_REVISE_SAGA = 'ASSOCIATE_MULTI_STATUS_REVISE_SAGA';
export const CULTURE_PROFILE_MULTI_STATUS_REVISE_SAGA = 'CULTURE_PROFILE_MULTI_STATUS_REVISE_SAGA';
export const UPDATE_SETUPSETUPPLUSFLAG = 'UPDATE_SETUPSETUPPLUSFLAG';
export const SET_SELECTED_BADGEVALUE = 'SET_SELECTED_BADGEVALUE';
export const SET_ASSESSEE_ASSESSMENT_SECTION_END_SAGA = 'SET_ASSESSEE_ASSESSMENT_SECTION_END_SAGA';
export const GET_ASSESSEE_MANUSCRIPT_VIDEOS_REVIEW_LIST_SAGA = 'GET_ASSESSEE_MANUSCRIPT_VIDEOS_REVIEW_LIST_SAGA';
export const SET_ASSIGNMENT_DYNAMIC_FRAMEWORK_STATE = 'SET_ASSIGNMENT_DYNAMIC_FRAMEWORK_STATE';
export const SET_ASSESSMENT_FRAMEWORK_TEMPLATE_ALIGNMENT_STATE =
  'SET_ASSESSMENT_FRAMEWORK_TEMPLATE_ALIGNMENT_STATE';
export const UPDATE_ASSESSMENT_SETUP_PRIMARY_INFO =
  'UPDATE_ASSESSMENT_SETUP_PRIMARY_INFO';
export const SET_ASSIGNMENT_FRAMEWORK_TEMPLATE_ALIGNMENT_STATE =
  'SET_ASSIGNMENT_FRAMEWORK_TEMPLATE_ALIGNMENT_STATE';
export const SET_ASSIGNMENT_GAUGE_STATE = 'SET_ASSIGNMENT_GAUGE_STATE';
export const SET_ASSIGNMENT_TIMELINE_STATE = 'SET_ASSIGNMENT_TIMELINE_STATE';
export const ASSOCIATE_EXCHANGE_REVISE_SAGA = 'ASSOCIATE_EXCHANGE_REVISE_SAGA';
export const CREATE_GAUGE_SAGA = 'CREATE_GAUGE_SAGA';
export const GET_GAUGE_REVISE_STATUS_SAGA = 'GET_GAUGE_REVISE_STATUS_SAGA';
export const GET_ASSIGNMENT_GUAGE_INFO_SAGA = 'GET_ASSIGNMENT_GUAGE_INFO_SAGA';
export const SET_JOB_CULTURE_PROFILER_REDUCER_STATE = 'SET_JOB_CULTURE_PROFILER_REDUCER_STATE';
export const SET_JOB_CULTURE_PROFILER_INFO_REDUCER_STATE =
  'SET_JOB_CULTURE_PROFILER_INFO_REDUCER_STATE';
export const CLEAR_JOB_CULTURE_REDUCER_STATE = 'CLEAR_JOB_CULTURE_REDUCER_STATE';
export const SET_JOB_CULTURE_PROFILER_CLUSTER_REDUCER_STATE =
  'SET_JOB_CULTURE_PROFILER_CLUSTER_REDUCER_STATE';
export const UPDATE_ASSESSEE_CREDENTIAL_INFO = 'UPDATE_ASSESSEE_CREDENTIAL_INFO';
export const SET_ASSIGNMENT_ALL_STATE = 'SET_ASSIGNMENT_ALL_STATE'; //

//market place Apis Constant
export const MARKET_PLACE_ASSESSEE_REVIEW_DISTINCT_SAGA = 'MARKET_PLACE_ASSESSEE_REVIEW_DISTINCT_SAGA'

export const QRDATA_VERIFICATION_SAGA = 'QRDATA_VERIFICATION_SAGA';
export const QRURL_VERIFICATION_SAGA = 'QRURL_VERIFICATION_SAGA';
export const RESEND_ASSIGNMENT_NOTIFICATION = 'RESEND_ASSIGNMENT_NOTIFICATION';
export const RESET_ASSESSEE_PASSWORD = 'RESET_ASSESSEE_PASSWORD';

export const ASSESSEE_MARKETPLACE_REVIEW_DISTINCT_SAGA = 'ASSESSEE_MARKETPLACE_REVIEW_DISTINCT_SAGA';
export const ASSESSEE_MARKETPLACE_REVIEW_GROUP_SAGA = "ASSESSEE_MARKETPLACE_REVIEW_GROUP_SAGA"
export const ASSESSEE_MARKETPLACE_REVIEW_NODE_SAGA = "ASSESSEE_MARKETPLACE_REVIEW_NODE_SAGA"
export const ASSESSEE_MARKETPLACE_REVIEW_ROLE_SAGA = "ASSESSEE_MARKETPLACE_REVIEW_ROLE_SAGA"
export const ASSESSEE_MARKETPLACE_REVIEW_TYPE_SAGA = "ASSESSEE_MARKETPLACE_REVIEW_TYPE_SAGA"

export const ASSESSMENT_MARKETPLACE_REVIEW_DISTINCT_SAGA = "ASSESSMENT_MARKETPLACE_PREVIEW_DISTINCT_SAGA"
export const ASSESSMENT_MARKETPLACE_REVIEW_GROUP_SAGA = "ASSESSMENT_MARKETPLACE_REVIEW_GROUP_SAGA"
export const ASSESSMENT_MARKETPLACE_REVIEW_NODE_SAGA = "ASSESSMENT_MARKETPLACE_REVIEW_NODE_SAGA"
export const ASSESSMENT_MARKETPLACE_REVIEW_TYPE_SAGA = "ASSESSMENT_MARKETPLACE_REVIEW_TYPE_SAGA"

export const ASSIGNMENT_MARKETPLACE_REVIEW_DISTINCT_SAGA = "ASSIGNMENT_MARKETPLACE_REVIEW_DISTINCT_SAGA"
export const ASSIGNMENT_MARKETPLACE_REVIEW_GROUP_SAGA = "ASSIGNMENT_MARKETPLACE_REVIEW_GROUP_SAGA"
export const ASSIGNMENT_MARKETPLACE_REVIEW_NODE_SAGA = "ASSIGNMENT_MARKETPLACE_REVIEW_NODE_SAGA"
export const ASSIGNMENT_MARKETPLACE_REVIEW_TYPE_SAGA = "ASSIGNMENT_MARKETPLACE_REVIEW_TYPE_SAGA"

export const ASSOCIATE_MARKETPLACE_REVIEW_DISTINCT_SAGA = "ASSOCIATE_MARKETPLACE_REVIEW_DISTINCT_SAGA"
export const ASSOCIATE_MARKETPLACE_REVIEW_GROUP_SAGA = "ASSOCIATE_MARKETPLACE_REVIEW_GROUP_SAGA"
export const ASSOCIATE_MARKETPLACE_REVIEW_NODE_SAGA = "ASSOCIATE_MARKETPLACE_REVIEW_NODE_SAGA"
export const ASSOCIATE_MARKETPLACE_REVIEW_ROLE_SAGA = "ASSOCIATE_MARKETPLACE_REVIEW_ROLE_SAGA"
export const ASSOCIATE_MARKETPLACE_REVIEW_TYPE_SAGA = "ASSOCIATE_MARKETPLACE_REVIEW_TYPE_SAGA"
export const ASSESSEE_SELF_REPORTS = "ASSESSEE_SELF_REPORTS"